class MessageSlider {
    constructor(sliderContainer) {
        this.slider = sliderContainer.querySelector(".c-message-slider-slides");
        this.prevBtn = sliderContainer.querySelector(".c-message-slider-prev");
        this.nextBtn = sliderContainer.querySelector(".c-message-slider-next");
        this.slides = Array.from(this.slider.querySelectorAll(".c-message-slider-content"));
        this.currentIndex = 0;
        this.isScrolling = false; // Flag to prevent multiple rapid clicks

        // Event Listeners
        this.prevBtn.addEventListener("click", () => this.changeSlide(-1));
        this.nextBtn.addEventListener("click", () => this.changeSlide(1));
        this.slider.addEventListener("scroll", this.syncScroll.bind(this));

        // Initial Button Visibility
        this.updateButtons();
    }

    changeSlide(direction) {
        if (this.isScrolling) return; // Prevent multiple clicks while scrolling

        this.isScrolling = true;
        this.currentIndex = Math.min(Math.max(this.currentIndex + direction, 0), this.slides.length - 1);

        this.slider.scrollTo({
            left: this.slides[this.currentIndex].offsetLeft,
            behavior: "smooth",
        });

        setTimeout(() => {
            this.isScrolling = false;
        }, 400); // Adjust timeout based on smooth scroll speed

        this.updateButtons();
    }

    syncScroll() {
        let scrollLeft = this.slider.scrollLeft;
        let closestIndex = this.slides.reduce((closest, slide, index) => {
            let offset = Math.abs(slide.offsetLeft - scrollLeft);
            return offset < Math.abs(this.slides[closest].offsetLeft - scrollLeft) ? index : closest;
        }, 0);

        this.currentIndex = closestIndex;
        this.updateButtons();
    }

    updateButtons() {
        this.prevBtn.style.display = this.currentIndex === 0 ? "none" : "block";
        this.nextBtn.style.display = this.currentIndex === this.slides.length - 1 ? "none" : "block";
    }
}

// Initialize the slider
document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".c-message-slider");
    if (slider) new MessageSlider(slider);
});
